import styled from "styled-components";

export const QuestionContent = styled.div`
  opacity: ${({ $isAnswered, $isCurrentOrPrevious }) =>
    $isCurrentOrPrevious ? 1 : $isAnswered ? 1 : 0.5};
  transition: opacity 0.3s ease-in-out;
  pointer-events: ${({ $isInteractive }) => ($isInteractive ? "auto" : "none")};

  ${({ $isInteractive }) =>
    !$isInteractive &&
    `
    cursor: not-allowed;
    
    * {
      cursor: not-allowed !important;
      pointer-events: none !important;
    }
    
    input, button, [role="button"], [role="radio"], [role="checkbox"] {
      opacity: 0.6;
    }
  `}

  ${({ $isInteractive }) =>
    $isInteractive &&
    `
    pointer-events: auto;
    
    * {
      pointer-events: auto;
    }
    
    input, button, [role="button"], [role="radio"], [role="checkbox"] {
      pointer-events: auto;
      cursor: pointer;
    }
  `}
`;
export const QuestionContainer = styled.div`
  .header {
    margin-bottom: 32px;
  }
`;

export const QuestionDescription = styled.p`
  font-size: 16px;
  color: #717184;
  margin: 0 0 2rem 0;
  font-weight: 400;
`;
